export default __webpack_public_path__ + "static/media/generate-policy.ba6dbb35.gif";